/* eslint-disable */
export default {
  space: '',
  do: '，',
  dot: '。',
  setting: '设置',
  chart: '统计',
  organization: '组织管理',
  allAccount: '所有账户',
  allDiseases: '所有病种',
  allOrganization: '所有组织',
  refresh: '刷新',
  username: '用户名',
  visiontech: '慧视AI',
  polymindf2fTitle: 'PolyMind AI 生成无创眼底荧光血管造影',
  EarlyPhase: '早期',
  LatePhase: '晚期',
  MedPhase: '中期',
  Angiography: '眼底血管造影视频',
  remark: '备注',
  userType: '用户类型',
  createUser: '创建用户',
  bindOrganization: '所属组织',
  createdAt: '创建时间',
  createdOrg: '创建组织',
  edit: '编辑',
  normal: '普通用户',
  userInfo: '用户信息',
  organization_admin: '组织管理员',
  users: '用户',
  reoprt: '报告',
  actions: '操作',
  signout: '退出登录',
  userPassword: '密码',
  allReport: '所有报告',
  IDText: '请输入ID查询',
  NameText: '请输入姓名查询',
  uploadText: '上传日期',
  export: '导出',
  reportType: '报告类型',
  view: '查看',
  copyButton: '备份数据',
  viewReport: '查看报告',
  type: '分类',
  assistantId: '助理编号',
  osnegative: '左眼（阴性）',
  ospositive: '左眼（阳性）',
  osungradable: '左眼（无法分级）',
  odnegative: '右眼（阴性）',
  odpositive: '右眼（阳性）',
  odungradable: '右眼（无法分级）',
  totalData: '筛查总量',
  Gradable: '可分级',
  negativeData: '阴性结果报告',
  positiveData: '阳性结果报告',
  halfgradbleData: '部分有结果报告',
  ungradableData: '无法分级报告',
  usableData: '有效率',
  noData: '无结果',
  positivePersentData: '阳性率',
  gradeNums: '阅片工作量',
  chartTotal: '统计指标',
  toDay: '当天',
  thisWeek: '本周',
  thisMonth: '本月',
  thisQuarter: '本季度',
  thisYear: '本年度',
  HistoryTotal: '历史总计',
  updatePassword: '修改密码',
  newPassword: '新设密码',
  confrimPassword: '确认密码',
  ageText: '输入的年龄不在评估模型的允许范围（40岁至80岁），结果将会是N/A（即无结果）。',
  naodos: 'N/A表示左右眼底相得出的风险等级差异较大，无法显示结果，属少数案例。但由于其中一张眼底相评估的风险等级较高，建议咨询医生意见，跟进相关风险。',
  // admin
  datepicker: '指定范围',
  startDate: '开始日期',
  to: '至',
  endDate: '结束日期',
  address: '地址',
  name: '姓名',
  birthday: '生日',
  mobile: '手机号',
  reportIsExist: '报告信息已存在，请不要重复提交',
  reportIsNone: '报告不存在，请检查路径',
  idcode: '身份证号码',
  chooseGender: '请选择性别',
  companyName: '慧视医疗',
  companyName2: 'Global STEM Professorship Scheme',
  adviceTitle: '转诊建议',
  patientId: 'ID',
  adviceText1: '存在阳性表现，建议眼科复诊；',
  adviceText2: '拍摄失败或分级失败，建议眼科复诊；',
  adviceText2_1: '可分级结果未见阳性表现，但少部分结果存在无法分级情况，如有不适，请及时就诊',
  adviceText3: '定期复诊。',
  adviceText4: '此人工智能分级结果只能作为诊断的参考依据，不可取代专业的医学意见、诊断或治疗。',
  information: '基本信息',

  eyeType: '拍摄模式',
  noPhoto: '拍摄失败或未拍摄',
  initing: '正在初始化...',
  findFundusSenor: '正在检查相机与传感器连接...',
  sensorText: '正在连接传感器...',
  fundusText: '正在连接相机...',
  back: '返回',
  shutdonw: '关机',
  submit: '确 定',
  cancel: '取 消',
  password: '管理员密码',
  title: '眼底拍照智能工作站',
  title1: '眼病筛查',
  title2: '心血管健康筛查',
  title3: '眼病筛查 + 心血管健康筛查',
  startText: '请点击按钮开始筛查',
  readme: '我已阅读并同意',
  usage: '使用条款',
  age: '年龄',
  gender: '性别',
  male: '男',
  female: '女',
  inputText: '请录入信息',
  startBtnText: '开始筛查',
  eyeReportTitle: '人工智能眼睛健康筛查報告',
  cvdReportTitle: '心血管疾病风险评估报告',
  endText1: '请取走您的报告。',
  endText2: '扫描二维码，可以将',
  endText3: '图片和报告传送到你的手机',
  ByeText1: '本次筛查已结束',
  ByeText2: '欢迎您下次光临',
  GradingText1: '拍照结束。',
  GradingText2: '系统正在智能分级中，',
  GradingText3: '即将生成报告。请稍后。',
  createdText: '拍照时间',
  od: '右眼',
  os: '左眼',
  ungradable: '不可分级',
  grading: '分级中',
  dr: '糖尿病性视网膜病变',
  amd: '年龄相关性黄斑变性',
  cataract: '重度白内障',
  glaucoma: '青光眼视神经病变',
  drnp: '糖尿病性视网膜病变',
  gradeFail: '分析失败',
  No_DR: '无明显的视网膜病变',
  Mild_NPDR: '轻度NPDR  ',
  Moderate_NPDR: '中度NPDR  ',
  Severe_NPDR: '重度NPDR  ',
  Proliferative_DR: 'PDR ',
  medium_risk: '中风险',
  high_risk: '高风险',
  low_risk: '低风险',
  negative: '阴性',
  positive: '阳性',
  cpositive: '可疑阳性',
  cvdResult: '评估结果',
  cvdPoint: '心血管疾病风险评分',
  Diseases: '病种',
  lowprobability: '可能性低',
  Possible: '有可能',
  early_or_intermediate: '早期或中期AMD',
  late_dry: '晚期干性AMD',
  late_wet: '晚期湿性AMD',
  cvdInfoTitle: '眼底图像及评估结果说明',
  cvdInfoText1: '双眼的眼底图像包括一张原始眼底照片，以及由人工智能系统自动生成的视网膜血管轮廓图像、标准区域血管测量和全视网膜血管测量图。',
  cvdInfoText2: 'N/A表示无结果。人工智能系统判别的年龄范围是40岁至80岁之间，超出此年龄范围，会显示N/A。',
  cvdInfoText3: '低风险人群建议每两年进行心脑血管检查一次；中度风险人群建议每6-12个月进行心脑血管检查一次；高风险人群建议每3个月进行心脑血管检查一次。',
  cvdInfoText4_1: '（从 0% 到 100%）：您的分数是',
  cvdInfoText4_2: '，表示您 10 年内发生心血管事件的风险评分（百分比），其中低风险为 < 10%，中度风险为 10-20%，高风险为 ≥ 20%。该结果由人工智能系统完全基于眼底照片呈现的血管情况判断生成。如果您的分数大于10%，则意味着您必须注意患心血管疾病的风险。',
  remarkTitle: '免责声明',
  remarkText: '此报告由广州慧视医疗科技有限公司的人工智能系统提供，心血管疾病风险评分是基于眼底照片、年龄、性别数据，使用目前先进的科研成果和人工智能技术分析评估得出。本报告不能替代专业建议或治疗，仅供临床专家参考。',
  remarkText2: '本報告由「Global STEM Professorship Scheme」支持下的人工智能系統所出具。請注意，本報告不應作為專業醫療建議或治療的替代，僅供臨床專家參考。',
  remarkText3: '此报告由OptiScreen的人工智能系统提供，心血管疾病风险评分是基于眼底照片、年龄、性别数据，使用目前先进的科研成果和人工智能技术分析评估得出。本报告不能替代专业建议或治疗，仅供临床专家参考。',
  cvdDoc_title: '心血管疾病风险科普',
  // 2024 10-14
  reportInfoTitle: '报告结果概览',
  noNormalDisease: '未发现明显常见眼病',
  normalDiseases: '常见眼病指需转诊的糖尿病视网膜病变、青光眼视神经病变、重度白内障。',
  normalDiseases2: '常见眼病指需转诊的糖尿病视网膜病变、年龄相关性黄斑变性、青光眼视神经病变。',
  remarkText4: '心血管疾病风险评分是基于眼底照片、年龄、性别数据，使用目前先进的科研成果和人工智能技术分析评估得出。此报告由OptiScreen及PolyMind AI的人工智能系统提供。',
  remarkTextPolyMind: '心血管疾病风险评分是基于眼底照片、年龄、性别数据，使用目前先进的科研成果和人工智能技术分析评估得出。此报告由PolyMind AI的人工智能系统提供。',
  remarkTextVisiontech: '心血管疾病风险评分是基于眼底照片、年龄、性别数据，使用目前先进的科研成果和人工智能技术分析评估得出。此报告由慧视医疗的人工智能系统提供。',
  Recommendations: '综合建议',
  imageQuality: '眼底图片质量分析',
  diseaseD: '眼病风险评估',
  cvdD: '心血管疾病风险评估',
  shootingSuccess: '拍摄成功',
  shootingFail: '拍摄不成功',
  success: '成功',
  other: '其他疾病',
  noOtherDisease: '未发现明显病变。',
  otherText: '*本系统可辅助识别 59 种常见眼病 和 61 种罕见眼病，结果仅供参考，不能替代医生的专业诊断与治疗。',
  fail: '不成功',
  shootingFailText: '无法拍摄到视网膜，建议重新拍摄。',
  Evaluate_grading_results: '评估分级结果',
  poorQuality: '图像质量不佳',
  interpretation_result: '分级结果解读',
  poorQuality_in: '图像质量不佳：表示您的眼底照片可能由于【瞳孔较小】，图像质量未达到分级标准。',
  cvd_result_title: '心血管健康风险评估结果',
  cvd_dcm_result_title: '血管分割与评估结果',
  retinal_arteriovenous_ratio: '视网膜动静脉比值',
  standard_value: '标准值',
  normal_standard: '视网膜动静脉比值在正常范围内。',
  unnormal_standard: '视网膜动静脉比值小于标准值。',
  standard_text: '视网膜动静脉比值指视网膜动脉和静脉的比值，正常情况下视网膜动脉与静脉的直径比为2:3 (0.67)。如果出现异常情况，可能是由于血管痉挛、高血压等原因导致，此时可能发生心血管疾病的风险会增加。',
  cvd_age: '视网膜年龄',
  your_cvd_age: '您的视网膜年龄是',
  smaller_age: '您的视网膜年龄小于实际年龄。表示您的生物学衰老程度相比同龄人更低。',
  older_age: '您的视网膜年龄大于实际年龄。表示您的生物学衰老程度相比同龄人更高。 ',
  remarkText5: '本报告不能替代专业的医疗建议或治疗，仅供临床专家参考。',
  odeye: '右眼',
  oseye: '左眼',
  glaucomaH2: '青光眼视神经病变',
  DRText: '疑似视网膜病变',
  HE: '出血',
  EX: '渗出',
  CWS: '棉绒斑',
  MA: '微血管瘤',
  fundus: '拍摄质量',
  // AnR
  public_Reject: '无法拍摄到视网膜，建议重新拍摄。',
  public_Usable: '',
  public_Good: '',
  other_negative_recommendations: '建议定期进行详细眼睛健康检查。',
  other_assessment: {
    "and neuroretinitis": "视神经网膜炎",
    "aneurysms": "视网膜动脉瘤",
    "vasculitis": "血管炎（眼部）",
    "behcet disease": "贝赫切特病",
    "best vitelliform macular dystrophy": "Best病（黄斑卵黄样营养不良）",
    "bietti's crystalline dystrophy": "别氏晶体样营养不良",
    "cmv retinitis": "巨细胞病毒性视网膜炎（CMV视网膜炎）",
    "coat's disease": "科茨病",
    "dalen–fuchs nodules": "Dalen–Fuchs 小结节",
    "eales' disease": "伊莱斯病",
    "hiv retinopathy": "HIV相关视网膜病变",
    "lyme disease": "莱姆病（眼部受累）",
    "stargardt disease": "斯塔加特病",
    "terson syndrome": "特森综合征",
    "vogt-koyanagi-harada disease": "Vogt-小柳-原田病（VKH）",
    "von hippel-lindau syndrome": "冯·希佩尔-林道综合征（VHL）",
    "x-linked juvenile retinoschisis ": "X连锁少年性视网膜劈裂",
    "abnormal": "异常（非特指）",
    "active toxoplasmosis": "活动性弓形虫性脉络膜视网膜炎",
    "acute posterior multifocal placoid pigment epitheliopathy": "急性后多灶性斑片状色素上皮病变（APMPPE）",
    "acute retinal necrosis": "急性视网膜坏死（ARN）",
    "adult-onset vitelliform macular dystrophy": "成人发病型卵黄样黄斑营养不良",
    "age-related macular degeneration": "老年性黄斑变性（AMD）",
    "albinism": "白化病（眼部）",
    "aneurysm": "视网膜动脉瘤",
    "angioid streak": "血管样条纹",
    "anterior ischemic optic neuropathy": "前缺血性视神经病变（AION）",
    "arterial-venous nicking": "动静脉交叉压迫（AV nicking）",
    "arteriosclerosis": "动脉硬化",
    "arteriovenous malformation": "动静脉畸形（AVM）",
    "arteriovenous shunts": "动静脉分流/短路",
    "asteroid bodies": "小体玻璃体病（Asteroid hyalosis）",
    "asteroid hyalosis": "小体玻璃体病（Asteroid hyalosis）",
    "atrophy": "萎缩（非特指）",
    "birdshot retinochoroidopathy": "鸟枪样脉络膜视网膜病变",
    "bone spicules pigmentation": "骨样棘突色素沉着（色素性视网膜炎提示）",
    "branch retinal artery occlusion": "分支视网膜动脉阻塞",
    "branch retinal vein occlusion": "分支视网膜静脉阻塞",
    "branching vascular network": "分支血管网络（PCV特征）",
    "bull's eye maculopathy": "靶样黄斑病变",
    "candida endophthalmitis": "念珠菌性眼内炎",
    "central areolar choroidal dystrophy": "中央凹脉络膜营养不良",
    "central retinal artery occlusion": "中央视网膜动脉阻塞（CRAO）",
    "central retinal vein occlusion": "中央视网膜静脉阻塞（CRVO）",
    "central serous chorioretinopathy": "中心性浆液性脉络膜视网膜病变（CSCR）",
    "chloroquine toxicity": "氯喹/羟氯喹毒性（黄斑病变）",
    "chorioretinal atrophy": "脉络膜视网膜萎缩",
    "chorioretinal dystrophy": "脉络膜视网膜营养不良",
    "choroidal detachment": "脉络膜脱离",
    "choroidal folds": "脉络膜皱襞",
    "choroidal hemangioma": "脉络膜血管瘤",
    "choroidal mass": "脉络膜肿块（未特指）",
    "choroidal melanoma": "脉络膜黑色素瘤",
    "choroidal metastasis": "脉络膜转移瘤",
    "choroidal neoplasm": "脉络膜肿瘤",
    "choroidal neovascularization": "脉络膜新生血管（CNV）",
    "choroidal nevus": "脉络膜痣",
    "choroidal osteoma": "脉络膜骨瘤",
    "choroidal rupture": "脉络膜破裂",
    "choroiditis": "脉络膜炎",
    "chronic central retinal vein occlusion": "慢性中央视网膜静脉阻塞",
    "chronic central serous chorioretinopathy": "慢性中心性浆液性脉络膜视网膜病变",
    "chronic retinal vein occlusion": "慢性视网膜静脉阻塞",
    "chronic toxoplasmosis": "慢性弓形虫病（眼部）",
    "cilioretinal artery occlusion": "睫状视网膜动脉阻塞",
    "combined hamartoma": "视网膜-视网膜色素上皮联合错构瘤",
    "commotio retinae": "视网膜震荡",
    "cone dystrophy": "圆锥细胞营养不良",
    "cone-rod dystrophy": "圆锥-杆细胞营养不良",
    "congenital anomaly": "先天畸形（未特指）",
    "congenital chorioretinal coloboma": "先天性脉络膜视网膜缺损（coloboma）",
    "congenital chorioretinopathy": "先天性脉络膜视网膜病变",
    "congenital choroideremia": "脉络膜缺如（Choroideremia）",
    "congenital coloboma": "先天性缺损（coloboma）",
    "congenital macular coloboma": "先天性黄斑缺损",
    "congenital optic disc coloboma": "先天性视盘缺损",
    "congenital stationary night blindness": "先天性停滞性夜盲（CSNB）",
    "congential optic disc abnormalities": "先天性视盘异常",
    "cotton-wool spot": "棉絮斑（软性渗出）",
    "cystoid macular edema": "囊样黄斑水肿（CME）",
    "detachment": "视网膜脱离（未特指）",
    "diabetic retinopathy": "糖尿病视网膜病变（DR）",
    "drusen": "玻璃膜疣（Drusen）",
    "dry age-related macular degeneration": "干性老年性黄斑变性",
    "edema": "水肿（非特指）",
    "endophthalmitis": "眼内炎",
    "epiretinal membrane": "黄斑前膜（ERM）",
    "exudate": "渗出物",
    "exudative retinal detachment": "渗出性视网膜脱离",
    "familial exudative vitreoretinopathy": "家族性渗出性玻璃体视网膜病变（FEVR）",
    "fibroproliferation": "纤维增殖（增殖性改变）",
    "fibrovascular retinal pigment epithelial detachment": "视网膜色素上皮纤维血管性隆起",
    "fleck": "斑点样病变",
    "gas-tamponade": "气体填充术（gas tamponade）",
    "geographic atrophy": "地理样萎缩（Geographic atrophy）",
    "glaucoma": "青光眼",
    "gyrate atrophy": "环状脉络膜视网膜萎缩",
    "hamartoma": "错构瘤（非特指）",
    "hard drusen": "硬性玻璃膜疣",
    "hemorrhage": "出血（眼内/视网膜）",
    "high myopia": "高度近视",
    "hyperpigmentation": "色素沉着（增强）",
    "hyperplastic retinal pigment epithelium": "视网膜色素上皮增生",
    "hypertensive retinopathy": "高血压性视网膜病变",
    "hypertrophy of the rpe": "视网膜色素上皮肥厚",
    "hypopigmentation": "色素减退",
    "idiopathic retinitis": "特发性视网膜炎",
    "infarction": "梗死（视网膜/视神经）",
    "intermediate uveitis": "中间型葡萄膜炎",
    "intraocular foreign body": "眼内异物",
    "intraretinal hemorrhage": "视网膜内出血",
    "intraretinal microvascular abnormalities": "视网膜内微血管异常（IRMA）",
    "ischemia": "缺血（视网膜）",
    "ischemic branch retinal vein occlusion": "缺血性分支视网膜静脉阻塞",
    "ischemic central retinal vein occlusion": "缺血性中央视网膜静脉阻塞",
    "ischemic optic neuropathy": "缺血性视神经病变",
    "lacquer crack": "漆裂（病理性近视相关）",
    "lamellar macular hole": "板层性黄斑裂孔",
    "large cup": "视杯增大（杯盘比增大）",
    "laser spots": "激光斑点（光凝术疤痕）",
    "late dry age-related macular degeneration": "晚期干性老年性黄斑变性",
    "lattice degeneration": "晶格样变性",
    "leukemic retinopathy": "白血病性视网膜病变",
    "lipemia retinalis": "视网膜脂血症",
    "lymphoma": "眼部淋巴瘤",
    "macroaneurysm": "视网膜动脉瘤",
    "macula off retinal detachment": "黄斑脱离型视网膜脱离",
    "macular atrophy": "黄斑萎缩",
    "macular dystrophy": "黄斑营养不良",
    "macular ectopia": "黄斑异位/移位",
    "macular edema": "黄斑水肿",
    "macular hemorrhage": "黄斑出血",
    "macular hole": "黄斑裂孔",
    "macular telangiectasia": "黄斑毛细血管扩张症（MacTel）",
    "maculopathy": "黄斑病变（未特指）",
    "mass": "肿块（眼内）",
    "media opacity": "介质混浊（角膜/晶体/玻璃体）",
    "melanocytoma": "黑色素细胞瘤（视盘黑素细胞瘤）",
    "melanoma": "黑色素瘤（脉络膜/葡萄膜）",
    "microaneurysm": "微动脉瘤",
    "mild nonproliferative diabetic retinopathy": "轻度非增殖性糖尿病视网膜病变",
    "moderate nonproliferative diabetic retinopathy": "中度非增殖性糖尿病视网膜病变",
    "morning glory syndrome": "晨光畸形（Morning glory syndrome）",
    "multifocal choroiditis": "多灶性脉络膜炎",
    "multiple evanescent white dot syndrome": "多灶性瞬时白点综合征（MEWDS）",
    "multiple myeloma": "多发性骨髓瘤（眼部改变）",
    "myelinated retinal nerve fiber layer": "视网膜髓鞘化神经纤维层",
    "myopia": "近视",
    "neoplasm": "肿瘤（未特指）",
    "neuroepithelial detachment": "神经上皮脱离",
    "neurofibromatosis": "神经纤维瘤病（眼部）",
    "neuroretinitis": "视神经网膜炎",
    "neuroretinopathy": "神经性视网膜病变",
    "nonperfusion area": "无灌注区",
    "nonproliferative diabetic retinopathy": "非增殖性糖尿病视网膜病变（NPDR）",
    "normal": "正常",
    "normal": "正常",
    "ocular candidiasis": "眼念珠菌病",
    "ocular histoplasmosis syndrome": "眼组织胞浆菌病综合征（OHS）",
    "ocular ischemic syndrome": "眼缺血综合征",
    "ocular parasitosis": "眼部寄生虫感染",
    "ocular tuberculosis": "眼结核",
    "old retinal vein occlusion": "既往（陈旧）视网膜静脉阻塞",
    "optic atrophy": "视神经萎缩",
    "optic disc drusen": "视盘小体 / 视盘钙化",
    "optic disc edema": "视盘水肿",
    "optic disc melanocytoma": "视盘黑色素细胞瘤",
    "optic disc neovascularization": "视盘新生血管形成",
    "optic disc pallor": "视盘苍白",
    "optic disc pit": "视盘裂孔",
    "optic nerve hypoplasia": "视神经发育不良",
    "optic neuritis": "视神经炎",
    "panuveitis": "全葡萄膜炎",
    "papillitis": "视神经乳头炎（乳头炎）",
    "pars plana vitrectomy": "巩膜平面玻璃体切除术（Pars plana vitrectomy, PPV）",
    "patchy chorioretinal atrophy": "斑片状脉络膜视网膜萎缩",
    "pathologic myopia": "病理性近视",
    "pattern dystrophy": "模式性黄斑营养不良",
    "perifoveal telangiectasia": "黄斑周围毛细血管扩张",
    "peripapillary atrophy": "视乳头周围萎缩",
    "pigmentary change": "色素改变",
    "plaquenil toxicity": "羟氯喹（Plaquenil）毒性（黄斑）",
    "polypoidal choroidal vasculopathy": "息肉样脉络膜血管病变（PCV）",
    "polypoidal vascular abnormality ": "息肉样血管异常（PCV）",
    "poor quality": "图像质量差",
    "posterior uveitis": "后葡萄膜炎",
    "posterior vitreous detachment": "玻璃体后脱离（PVD）",
    "preretinal hemorrhage": "视网膜前出血",
    "presumed ocular histoplasmosis syndrome": "假定眼组织胞浆菌病综合征（POHS）",
    "proliferative diabetic retinopathy": "增殖性糖尿病视网膜病变（PDR）",
    "proliferative vitreoretinopathy": "增殖性玻璃体视网膜病变（PVR）",
    "pseudopapilledema": "假性乳头水肿",
    "pseudoxanthoma elasticum": "假黄色瘤样弹性纤维变性（PXE）",
    "punctate inner choroidopathy": "点状脉络膜病变（PIC）",
    "radiation retinopathy": "放射性视网膜病变",
    "red small dots": "小红点（非特指）",
    "referable diabetic retinopathy": "需转诊的糖尿病视网膜病变",
    "retinal angiomatous proliferation": "视网膜血管母细胞增殖（RAP）",
    "retinal arterial macroaneurysm": "视网膜动脉瘤",
    "retinal artery occlusion": "视网膜动脉阻塞",
    "retinal capillary hemangioblastoma": "视网膜毛细血管血管母细胞瘤（RCH）",
    "retinal cavernous hemangioma": "视网膜海绵状血管瘤",
    "retinal collateral": "视网膜侧支血管",
    "retinal detachment": "视网膜脱离",
    "retinal dystrophy": "视网膜营养不良（未特指）",
    "retinal neovascularization": "视网膜新生血管",
    "retinal pigment epithelial detachment": "视网膜色素上皮剥离（PED）",
    "retinal pigment epithelial tears": "视网膜色素上皮撕裂",
    "retinal pigment epithelium hamartoma": "视网膜色素上皮错构瘤",
    "retinal tear": "视网膜裂孔",
    "retinal telangiectasia": "视网膜毛细血管扩张",
    "retinal vein occlusion": "视网膜静脉阻塞（RVO）",
    "retinal vessel attenuation": "视网膜血管变细",
    "retinitis": "视网膜炎",
    "retinitis pigmentosa": "色素性视网膜炎 / 视网膜色素变性（RP）",
    "retinoblastoma": "视网膜母细胞瘤",
    "retinopathy of prematurity": "早产儿视网膜病变（ROP）",
    "retinoschisis": "视网膜劈裂",
    "rhegmatogenous retinal detachment": "裂孔性视网膜脱离",
    "roth spots": "Roth斑",
    "sarcoidosis": "结节病（眼部）",
    "scar": "瘢痕",
    "scleral band": "巩膜带 / 环形带",
    "serous pigment epithelial detachment": "浆液性色素上皮剥离（serous PED）",
    "serous retinal detachment": "浆液性视网膜脱离",
    "serpiginous choroiditis": "蛇行性脉络膜炎",
    "severe nonproliferative diabetic retinopathy": "重度非增殖性糖尿病视网膜病变",
    "sickle cell retinopathy": "镰状细胞性视网膜病变",
    "silicone-oil-tamponade": "硅油填充（术后）",
    "solar retinopathy": "日光性视网膜病变",
    "staphyloma": "巩膜葡萄肿（posterior staphyloma）",
    "subhyaloid hemorrhage": "玻璃体下（膜下）出血",
    "submacular hemorrhage": "黄斑下出血",
    "subretinal exudate": "视网膜下渗出",
    "subretinal fibrosis": "视网膜下纤维化",
    "subretinal hemorrhage": "视网膜下出血",
    "sympathetic ophthalmia": "交感性眼炎",
    "syphilis": "梅毒（眼部）",
    "systemic lupus erythematosus vasculitis": "系统性红斑狼疮相关血管炎",
    "tessellation": "棋盘样眼底（tessellation）",
    "tortuous": "血管迂曲",
    "toxocariasis": "弓蛔虫病（Toxocara眼部感染）",
    "toxoplasmosis": "弓形虫病（眼部）",
    "traction": "牵拉（未特指）",
    "tractional retinal detachment": "牵拉性视网膜脱离",
    "tuberculosis": "结核（眼部）",
    "uveitis": "葡萄膜炎",
    "valsalva retinopathy": "瓦尔萨尔瓦（Valsalva）性视网膜病变",
    "vascular hamartoma": "血管错构瘤",
    "vascular sheath": "血管鞘样改变",
    "vasculitis": "血管炎（眼部）",
    "venous loop": "静脉环",
    "viral retinitis": "病毒性视网膜炎（HSV/VZV/CMV等）",
    "vitelliform macular dystrophy": "卵黄样黄斑营养不良",
    "vitreomacular traction syndrome": "玻璃体-黄斑牵拉综合征",
    "vitreous degeneration": "玻璃体退行性变",
    "vitreous hemorrhage": "玻璃体出血",
    "vitreous opacity": "玻璃体混浊 / 浮动物",
    "vitritis": "玻璃体炎",
    "wet age-related macular degeneration": "湿性老年性黄斑变性",
    "white dot syndrome": "白点综合征（一组疾病）"
  },
  // drnp
  drnp_negative_assessment: '未发现明显糖尿病性视网膜病变。',
  drnp_negative_recommendations: '建议定期进行详细眼睛健康检查。',
  drnp_positive_assessment: '高度怀疑存在糖尿病性视网膜病变, 请尽快谘询专业人士作详细检查。',
  drnp_positive_recommendations: '眼底照片存在糖尿病性视网膜病变类似异常，可能由糖尿病引起，建议諮询视光师或眼科医生作进一步检查和治疗。如不及时就诊治疗，可能引起视力下降甚至导致失明。应注意控制血糖，均衡饮食，适度运动。',
  drnp_ungradable_assessment: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。',
  drnp_ungradable_recommendations: '建议重新拍摄或到专业护眼中心进行详细检查。',
  // glaucoma
  glaucoma_negative_assessment: '未发现明显青光眼视神经病变。',
  glaucoma_positive_assessment: '存在青光眼视神经病变的风险较高，如不及时就诊治疗，可能引起视野缩窄等视功能障碍。',
  glaucoma_negative_recommendations: '建议定期进行详细眼睛健康检查。',
  glaucoma_positive_recommendations: '存在高风险的青光眼视神经病变类似异常，很有可能是视神经受损的表现，建议谘询视光师或眼科医生的意见，接受进一步检查和治疗。如不及时就诊治疗，可能引起视野缩窄等视功能障碍。',
  glaucoma_low_risk_assessment: '未发现明显青光眼视神经病变。',
  glaucoma_low_risk_recommendations: '建议定期进行详细眼睛健康检查。',
  glaucoma_medium_risk_assessment: '存在青光眼视神经病变的风险为中等。',
  glaucoma_medium_risk_recommendations: '存在中度风险的青光眼视神经病变类似异常，可能是视神经受损，亦可能是个人生长差异，建议谘询视光师或眼科医生的意见，接受进一步检查。',
  glaucoma_high_risk_assessment: '存在青光眼视神经病变的风险较高，如不及时就诊治疗，可能引起视野缩窄等视功能障碍。',
  glaucoma_high_risk_recommendations: '存在高风险的青光眼视神经病变类似异常，很有可能是视神经受损的表现，建议谘询视光师或眼科医生的意见，接受进一步检查和治疗。如不及时就诊治疗，可能引起视野缩窄等视功能障碍。',
  glaucoma_ungradable_assessment: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。',
  glaucoma_ungradable_recommendations: '建议重新拍摄或到专业护眼中心进行详细检查。',
  // cataract
  cataract_negative_assessment: '未发现明显重度白内障风险。',
  cataract_negative_recommendations: '建议定期进行眼部健康检查。',
  cataract_positive_assessment: '可能存在重度白内障或会引致视力下降。',
  cataract_positive_recommendations: '眼底照片发现可疑重度白内障类似异常，可能是由于晶状体混浊或其它眼睛结构混浊引起，建议谘询视光师或眼科医生的意见，接受进一步检查和治疗。如不及时就诊治疗，可能引致视力下降。',
  cataract_ungradable_assessment: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。',
  cataract_ungradable_recommendations: '建议重新拍摄或到专业护眼中心进行详细检查。',
  // amd
  amd_negative_assessment: '未发现明显年龄相关性黄斑变性风险。',
  amd_negative_recommendations: '建议定期进行眼部健康检查。',
  amd_positive_assessment: '可能存在龄相关性黄斑变性。',
  amd_positive_recommendations: '眼底照片发现可疑龄相关性黄斑变性异常。',
  amd_ungradable_assessment: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。',
  amd_ungradable_recommendations: '建议重新拍摄或到专业护眼中心进行详细检查。',
  // cvd
  cvd_low_risk_recommendations: '低⾵险⼈群建议每年进⾏⼼脑⾎管及身体检查⼀次;',
  cvd_medium_risk_recommendations: '中度⾵险⼈群建议谘询医生意见，跟进⼼脑⾎管健康风险;',
  cvd_high_risk_recommendations: '⾼⾵险⼈群建议尽快谘询医生意见，及早跟进⼼脑⾎管健康风险。',
  cvd_NA_40_80_recommendations: '⼈⼯智能系统适用的年龄范围是40岁⾄80岁之间，超出此年龄范围，会显⽰N/A。',
  cvd_NA_recommendations: 'N/A表示左右眼底相得出的风险等级差异较大，因此无法显示结果，属少数案例。但由于其中一张眼底相评估的风险等级较高，建议咨询医生意见，跟进相关风险。',
  cvd_ungradable_assessment: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。',
  cvd_ungradable_recommendations: '建议重新拍摄或到专业护眼中心进行详细检查。',
  // total recommend
  all_negative_recommendations: '建议定期进行眼睛健康检查。',
  all_positive_recommendations: '建议咨询视光师或眼科医生的意见，定期重新复查眼底及心血管健康风险。',
  all_positive_recommendations_2: '注意均衡饮食、控制血糖和血压，适量运动。维持良好的生活习惯，密切关注自身健康状况。',
  half_ungradable_recommendations: '注意均衡饮食、控制血糖和血压，适量运动，维持良好的生活习惯，密切关注自身健康状况，建议定期重新複查眼底及心血管健康风险。',
  all_ungadable_recommendations: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。建议重新拍摄或到专业护眼中心进行详细检查。',
  half_ungradable_text: '图像质量不达分级标准，系统无法完成分析，可能原因包括但不限于瞳孔小，未能注视指示灯，拍摄时眨眼等。建议重新拍摄或到专业护眼中心进行详细检查。',
  cvddoc: {
    p1_title: '一、什么是心血管疾病？',
    p1_1: '心血管疾病是关于心脏或者血管的疾病，又称循环系统疾病，是一系列涉及循环系统的疾病。主要包括：缺血性心脏病、脑中风、心肌病、风湿性心脏病、高血压心脏病、心内膜炎、心律不正、主动脉疾病、外周动脉疾病以及其它心血管和循环系统疾病。心血管疾病严重危害患者的身体健康，目前已成为人类的首位死亡原因。',
    p2_title: '二、诱发心血管疾病的病因',
    p2_1: '心血管疾病病因複杂，属于多因素致病，包括生物和遗传因素、环境因素、不良的生活方式等。',
    p2_3_s: '基本病因',
    p2_3: '：心血管疾病的直接病因或高危因素主要是吸烟、缺乏运动、肥胖、高血压、血脂异常、糖尿病、感染和遗传，其它还包括饮食不均衡和空气污染等。多种因素并非独立存在，而是呈现聚集态势，互相影响，共同导致心血管疾病的发病。',
    p2_4_s: '遗传因素',
    p2_4: '：遗传因素是心血管疾病发病的独立高危因素，有家族史的人士，其心血管疾病发病风险增加。',
    p2_5_s: '高血压',
    p2_5: '：高血压是心血管疾病发病的主要高危因素。研究显示，在35至64岁人士当中，有36.1%的心血管疾病个案可归因于高血压。高血压患者患冠心病的概率比没有高血压者增加3至4倍。',
    p2_6_s: '血脂异常',
    p2_6: '：血脂是血浆中的中性脂肪（胆固醇、甘油三酯）和类脂（磷脂、糖脂、固醇、类固醇等）的总称，血脂异常通常指血清胆固醇、甘油三酯、低密度脂蛋白胆固醇水平升高，高密度脂蛋白胆固醇水平降低，这与临床心血管疾病密切相关，尤其是低密度脂蛋白胆固醇升高。长期血脂异常可导致动脉壁形成粥样斑块，使管壁逐渐狭窄甚至闭塞。斑块也可发生破裂，血小板聚集、血栓形成，阻塞血流，从而引发心肌梗死、脑中风，甚至猝死。',
    p2_7_s: '糖尿病',
    p2_7: '：糖尿病是冠心病、脑中风等心血管疾病的重要危险因素。',
    p2_8_s: '肥胖',
    p2_8: '：肥胖与心血管疾病的发病、发展相关，肥胖者动脉粥样硬化危险增加，同时肥胖併发高血压、糖尿病、血脂异常等其他疾病的风险增加。',
    p2_9_s: '其他因素：',
    p2_9: '高盐摄入、高脂肪摄入、食品污染、过量饮酒、缺乏蔬菜水果等不均衡饮食，以及环境污染、空气污染等都可增加患心血管病的风险。',
    p3_title: '三、心血管疾病的症状',
    p3_1_s: '早期症状',
    p3_1: '：心血管疾病多起病隐匿，患者在早期可以无特异性症状，有的表现为不明显的胸闷、心悸、乏力、头晕等。',
    p3_2_s: '典型症状',
    p3_2: '：心血管疾病种类比较多，主要常见的症状有胸闷、胸痛、心悸、水肿、头痛、头晕、体能下降、呼吸困难、晕厥，其他还包括发绀、咳嗽、眩晕(与头晕有分别)、上腹胀痛、恶心、呕吐等。(部分症状也见于其它系统疾病，因此应仔细鉴别)。',
    p4_title: '四、心血管疾病风险评估的作用',
    p4_1: '我们採用国际标准的心血管疾病风险等级进行划分，风险等级为三类(高、中、低)：',
    p4_7: '评分依据：',
    p4_8: '①利用人工智能模型判断眼底照片是否呈现心血管疾病特征，计算风险值；',
    p4_9: '②视网膜年龄比实际年龄每大一岁，则风险评分增加4%；',
    p4_10: '③年龄因素：年龄越大，风险越高；',
    p4_11: '④性别因素：男性患病风险高于女性；',
    p4_12: '根据以上四个因素，AI模型进行综合分析，给出心血管风险评估分数。',
    p5_title: '五、心血管疾病的预防',
    p5_1: '饮食均衡，宜低盐、低脂，烹调时尽量使用植物油，主食应粗粮与细粮搭配，多食用高热量且营养丰富的食物，如：瘦肉、鸡、鱼、乳类及豆制品，少食油腻食物，多食新鲜蔬菜和水果，少食油炸食品，禁烟戒酒。',
    p5_2: '应坚持适当的运动，如：户外散步、慢跑、游泳等。每天运动30～60分钟，按照个人身体状况做不同的调整。',
    p6_title: '六、就诊',
    p6_1: '当出现胸闷、胸痛、心悸、晕厥、头痛、头晕、呼吸困难等异常情况时，应及时就医，尤其有高血压、血脂异常、高血糖等疾病史，吸烟、肥胖以及心血管疾病家族史的患者。',
    p7_title: '提示：本报告仅供参考，不能替代专业建议或治疗。'
  },
  eyedoc_title_1: '建议解读',
  eyedoc1: {
    p1_1_s: '无法分级',
    p1_1: '：表⽰您的眼底照片未达到分级标准。',
    p1_2_s: '阴性',
    p1_2: '：表⽰您的眼底照片显⽰未⾒相关病变，定期複查即可。',
    p1_3_s: '可疑阳性及阳性',
    p1_3: '：表⽰您的眼底照片显⽰疑似存在或存在病变的情况，请根据转诊建议及时就诊。',
    p1_4_s: '低风险',
    p1_4: '：表示您的眼底照片显示存在病变的风险较低，请定期複查。',
    p1_5_s: '中风险或高风险',
    p1_5: '：表示您的眼底照片显示存在病变的风险为中度或高度，请根据转诊建议及时就诊。'
  },
  eyedoc_amd: {
    p1_1_s: '无法分级',
    p1_1: '：表⽰您的眼底照片未达到分级标准。',
    p1_2_s: '可能性低',
    p1_2: '：表⽰您的眼底照片显⽰未⾒相关病变，定期複查即可。',
    p1_3_s: '有可能',
    p1_3: '：表⽰您的眼底照片显⽰疑似存在或存在病变的情况，请根据转诊建议及时就诊。',
    p1_4_s: '低风险',
    p1_4: '：表示您的眼底照片显示存在病变的风险较低，请定期複查。',
    p1_5_s: '中风险或高风险',
    p1_5: '：表示您的眼底照片显示存在病变的风险为中度或高度，请根据转诊建议及时就诊。'
  },
  eyedoc_dr: {
    p1_1_s: '无法分级',
    p1_1: '：表示您的眼底照⽚未达到分级标准。',
    p1_2_s: '阴性',
    p1_2: '：表示您的眼底照⽚显示未出现糖尿病性视网膜病变，建议定期复查。',
    p1_3_s: '可疑阳性及阳性',
    p1_3: '：表示您的眼底照⽚显示存在糖尿病性视网膜病变，请您根据转诊建议及时就诊。'
  },
  eyedoc_title_2: '糖网科普',
  eyedoc2: {
    p1_1: '糖尿病视网膜病变（简称“糖网”）是糖尿病并发症的一种，发病概率与糖尿病类型、发病时间、治疗方式等因素关系密切。',
    p1_2: '糖网常见症状：视物模糊，视力下降、失明等。',
    p1_3: '关于糖网，您需要知道的：',
    p2_title: '一、糖尿病类型的影响',
    p2_1: '糖尿病视网膜病变可能是因为糖尿病患者的血糖长期处于较高的状态，从而使眼部微血管出现缺氧、缺血性改变，引起眼底新生血管形成，伴有局部出血等情况，可能会导致视物变形、视力下降等，情况较为严重时可能会有视力丧失，1型糖尿病患者糖尿病视网膜病变的发病率在90%左右，而2型糖尿病患者糖尿病视网膜病变的发病率为50%-80%。',
    p3_title: '二、糖网发病时间',
    p3_1: '若患糖尿病的时间在10年以上，则糖尿病视网膜病变的可能性在69%-90%，20年以上的患者几乎100%都存在糖尿病视网膜病变。',
    p4_title: '三、糖尿病治疗方式对糖网的影响',
    p4_1: '主要看是否使用胰岛素，使用胰岛素控制血糖的糖尿病患者，糖尿病视网膜病变发生几率约为80%，而未使用胰岛素的糖尿病患者，糖尿病视网膜病变的发生几率约为50%。',
    p5_title: '四、糖尿病视网膜病变的预防',
    p5_1: '糖尿病患者在日常生活管理基础上，应更加爱护眼睛、保护眼睛。建议吃富含膳食纤维，或者让血糖上升较慢的碳水化合物食物如蔬菜、豆类、水果、全麦面包和谷类食品等；提倡摄入深海鱼、鸡蛋、大豆等优质蛋白；适当补充维生素D、维生素C有助于溃疡的愈合。少吃多餐，规律饮食。',
    p5_2: '可通过视力检查或定期眼底拍照检查进行监测，一旦视力低于4.8，或患者出现突发的视力下降以及视物模糊应及时就诊。',
    p6_title: '五、糖尿病视网膜病变的检查、确诊与治疗：',
    p6_1_s: '· 检查',
    p6_1: '：眼底镜检查，或眼底彩色照相检查就可以确诊。但如果眼底有出血点，建议做眼底荧光血管造影检查，这样可以更清楚地了解糖尿病视网膜病变的程度。',
    p6_2_s: '· 确诊',
    p6_2: '：糖网以是否有从视网膜发出的异常新生血管作为判断标准，可分为增殖性糖尿病视网膜病变和非增殖性糖尿病视网膜病变。',
    p6_3_s: '· 治疗',
    p6_3: '：近年来，医药科技进步很快，尤其是抗血管生成药物的出现，使糖尿病视网膜病变的治疗有了更多的选择，比如，激光联合抗血管生成药物玻璃体腔注射治疗，对控制黄斑水肿会有更好的效果；比如，对已经有新生血管形成的病例，玻璃体腔注射抗血管生成药物，可以帮助新生血管的退缩，尤其新生血管在视神经乳头上无法进行激光治疗时；有些糖尿病视网膜病变晚期，必须手术的病例，也可以先注射药物，然后再手术，这样可减少术中出血。',
    p7_title: '提示：如您的分级结果是阳性，请参考就诊建议，去医院眼科或眼科专科医院寻求医生的帮助。本报告仅供参考，不能替代专业建议或治疗。'
  },
  eyedoc_title_3: '青光眼科普',
  eyedoc3: {
    p1_title: '一、什麽是青光眼？',
    p1_1: '青光眼是一种逐渐进展的眼部疾病，通常与眼压升高有关。它会对视神经造成损伤，可能导致视野损失和失明。大部分的青光眼通常在早期没有明显症状，患者难以察觉。',
    p2_title: '二、青光眼的分类',
    p2_1: '青光眼可以分为开角型和闭角型。开角型青光眼房角正常但排水不通，闭角型青光眼则是由于虹膜与角膜之间的角房角狭窄造成眼压急剧升高。',
    p3_title: '三、青光眼的分类及症状',
    p3_1: '青光眼可以分为慢性和急性，而青光眼个案中有超过8成属慢性。慢性青光眼比急性青光眼更危险，往往去到中后期才会有较明显的症状，可能对视力已造成无法复原的损害。',
    p3_2: '急性：因眼压急剧升高而导致出现眼红、眼部疼痛、视力模糊、看灯光有彩虹圈、头痛、噁心及呕吐等明显症状。',
    p3_3: '慢性：早期并没有明显症状，但随著病情渐渐恶化，视力会下降及视野缩窄，大部分在患者发觉时能己到中后期。',
    p4_title: '四、青光眼的检查与治疗',
    p4_1: '检查青光眼通常包括眼压测量、眼底检查、视野测试和视神经检查。治疗方法包括使用药物降低眼压、手术增加眼部排水、激光治疗等。早期诊断和治疗是预防青光眼进展的关键。',
    p4_2: '青光眼是一个严重的眼部疾病，早期青光眼只能透过定期眼部检查和及早发现及治疗，可以控制病情并保护视力。如有疑虑，请寻求专业医生或眼科视光师的指导和建议。'
  },
  eyedoc_title_4: '年龄相关性白内障科普',
  eyedoc4: {
    p1_title: '一、什麽是年龄相关性白内障？',
    p1_1: '年龄相关性白内障是一种常见的眼部疾病，通常与年龄的增长有关。它是由于眼中的晶状体变得混浊，影响到正常视力。这种白内障可以逐渐发展，并且在年长时更加普遍。',
    p2_title: '二、年龄相关性白内障的症状',
    p2_1: '年龄相关性白内障的常见症状包括视力模糊、感觉像有雾气或薄雾在眼前、对比度降低、颜色感知减退等。这些症状可能会逐渐加重，影响日常生活和活动。',
    p3_title: '三、年龄相关性白内障的检查与治疗',
    p3_1: '检查年龄相关性白内障通常包括眼部检查、视力测试和眼底检查。治疗方法主要是通过手术来取出混浊的晶状体，并植入人工晶体来恢复视力。这种手术被称为白内障摘除手术，是一种安全且常见的手术。',
    p3_2: '年龄相关性白内障是普遍的眼部问题，但通过正确的检查和及时的手术治疗，可以恢复视力并提高生活质量。建议年长者定期进行眼部检查，并寻求专业医生的建议和指导。'
  },
  eyedoc_title_5: '年龄相关性黄斑变性信息',
  eyedoc5: {
    p1_1: '年龄相关性黄斑变性（Age-Related Macular Degeneration，简称AMD或ARMD）是一种与年龄增长相关的眼病，主要影响眼睛的黄斑区。黄斑区位于视网膜中心，是负责中央视觉和细节识别（如阅读、面部识别和驾驶）的重要部位。AMD是导致50岁以上人群视力丧失的主要原因之一。',
    p2_title: '一、AMD的类型',
    p2_1: 'AMD主要有两种类型：',
    p2_2: '● 干性AMD：这是最常见的形式，占所有AMD病例的85%-90%。干性AMD的特点是黄斑区的光感受器细胞逐渐退化和死亡，形成小的黄色沉积物（称为玻璃体疣）。这种类型的AMD进展缓慢，通常影响双眼，但可能导致中心视力逐渐丧失。',
    p2_3: '● 湿性AMD：这种类型的AMD较为严重，占所有AMD病例的10%-15%。湿性AMD是由于异常血管在黄斑区生长，导致血液和液体渗漏，进而引起视网膜损伤和瘢痕形成。湿性AMD的进展速度快，可能导致严重的中心视力丧失。',
    p3_title: '二、AMD的症状',
    p3_1: 'AMD的症状取决于其类型：',
    p3_2: '● 干性AMD：早期可能无症状或仅有轻微的视觉模糊。随着病情进展，可能会出现视觉中心的盲点或直线变形。',
    p3_3: '● 湿性AMD：症状通常突然出现，包括视力急剧下降、视觉中心模糊或失真，以及单眼失明。',
    p4_title: '三、AMD的风险因素',
    p4_1: 'AMD的风险因素包括：',
    p4_2: '● 年龄增长',
    p4_3: '● 家族史',
    p4_4: '● 吸烟',
    p4_5: '● 心脏病',
    p4_6: '● 超重',
    p4_7: '● 高血压',
    p4_8: '● 高血脂',
    p4_9: '● 某些遗传因素',
    p4_10: '● 长期暴露于阳光下',
    p4_11: '● 营养不良（如缺乏Ω-3脂肪酸）',
    p5_title: '四、AMD的诊断',
    p5_1: 'AMD的诊断通常通过眼科检查进行，医生可能会要求患者注视一个网格（称为Amsler网格），以检查视力和视网膜的异常。此外，医生可能会使用特殊的成像技术（如眼底拍照）来观察眼睛的内部结构。',
    p6_title: '五、AMD的治疗',
    p6_1: 'AMD的治疗取决于其类型和严重程度：',
    p6_2: '● 干性AMD：目前没有特效治疗方法，但补充剂（如叶黄素和玉米黄质）可能有助于减缓病情进展。',
    p6_3: '● 湿性AMD：治疗通常包括眼内注射抗血管内皮生长因子（anti-VEGF）药物，如艾力雅®（阿柏西普），以及激光光凝和玻璃体手术等。',
    p7_title: '六、AMD的预防',
    p7_1: '预防AMD的措施包括：',
    p7_2: '● 戒烟',
    p7_3: '● 健康饮食，增加Ω-3脂肪酸的摄入',
    p7_4: '● 控制血压和体重',
    p7_5: '● 保护眼睛免受紫外线伤害',
    p7_6: '随着人口老龄化的加剧，AMD的患者数量预计将持续上升。因此，提高公众对AMD的认识，以及推广早期诊断和治疗，对于保护老年人的视力至关重要。',
    p7_7: '提示：本报告仅供参考，不能替代专业建议或治疗，请根据自身情况，考虑寻求眼科专科医生帮助。'
  }
}
